import React, { useState } from 'react';
import axios from 'axios';
import { API_URLS } from '../../config/api';

const TestForm = () => {
  const [formData, setFormData] = useState({
    housingType: 'Maison',
    ownerStatus: 'Propriétaire',
    instalationType: ['Pompe a chaleur'],
    ageOfHouse: 'Entre 2 ans et 15 ans',
    typeOfEnergy: 'Gaz',
    postalCode: '75001',
    sexe: 'Monsieur',
    firstName: 'Test',
    lastName: 'Frontend',
    phone: '0123456789',
    userInfos: JSON.stringify({ source: 'test-form', timestamp: new Date().toISOString() })
  });

  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await axios.post(API_URLS.submit, formData);
      setResponse(result.data);
      console.log('✅ Formulaire envoyé avec succès:', result.data);
    } catch (error) {
      setResponse({ success: false, error: error.message });
      console.error('❌ Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const testApiConnection = async () => {
    try {
      const result = await axios.get(API_URLS.test);
      console.log('🚀 API Connection:', result.data);
      alert('✅ API connectée !');
    } catch (error) {
      console.error('❌ API Error:', error);
      alert('❌ Erreur API');
    }
  };

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '20px auto', 
      padding: '20px', 
      border: '1px solid #ddd', 
      borderRadius: '8px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2>🧪 Test Formulaire LocaJoy → Google Sheets</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testApiConnection}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          🔌 Test API Connection
        </button>
        
        <a 
          href="https://docs.google.com/spreadsheets/d/1ESbK5nmdQp-tOzOhI5E9cXTaN1Gfn6npEP4dQvVIflM/edit" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            display: 'inline-block'
          }}
        >
          📊 Voir Google Sheets
        </a>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label>Prénom:</label>
          <input 
            type="text" 
            value={formData.firstName}
            onChange={(e) => setFormData({...formData, firstName: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Nom:</label>
          <input 
            type="text" 
            value={formData.lastName}
            onChange={(e) => setFormData({...formData, lastName: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Téléphone:</label>
          <input 
            type="text" 
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Code postal:</label>
          <input 
            type="text" 
            value={formData.postalCode}
            onChange={(e) => setFormData({...formData, postalCode: e.target.value})}
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <button 
          type="submit" 
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: loading ? '#6c757d' : '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {loading ? '⏳ Envoi en cours...' : '🚀 Envoyer vers Google Sheets'}
        </button>
      </form>

      {response && (
        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          backgroundColor: response.success ? '#d4edda' : '#f8d7da',
          border: `1px solid ${response.success ? '#c3e6cb' : '#f5c6cb'}`,
          borderRadius: '4px'
        }}>
          <h4>{response.success ? '✅ Succès!' : '❌ Erreur'}</h4>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestForm;